import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`Payment Errors`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Error ID`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Recovery Suggestion`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`payment-failed`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returned when processing a payment has failed.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Contact Primer and provide us with diagnostics id.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`failed-to-create-payment`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returned when there is a failure in the internal SDK create payment call.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Contact Primer and provide us with diagnostics id.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`failed-to-resume-payment`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returned when there is a failure in the internal SDK resume payment call.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Contact Primer and provide us with diagnostics id.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`payment-cancelled`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returned when the payment was cancelled by the user.`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      